module.exports = "<div class=\"container-fluid container-limited\">\n\n<div class=\"row\">\n\t<div class=\"col-sm-12\">\n\t\t<h1 translate>API_FAILED_Title</h1>\n\t\t<h5 translate>API_FAILED_Hint</h5>\n\t\t<p translate>{{msg}}</p>\n\t</div>\n</div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/account/other/apifailed.html
// module id = 124
// module chunks = 0